import Input from './input'

class FormFilter extends React.Component {
  constructor(props) {
    super(props)

    let defaultFilter = {
      type: 'filter',
      kind: this.props.type
    }

    this.state = {
      loading: false,
      filter: this.props.filter ? Object.assign({}, defaultFilter, this.props.filter) : defaultFilter
    }
  }

  componentDidUpdate(prevProps) {
    window.select2(`.select2-users-wrapper`)
    const _this = this

    jQuery("#select2-users").off('change')
    jQuery("#select2-users").on('change', (e) => {
      _this.handleInputChange(e)
    })
  }

  handleInputChange(e) {
    const target = e.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    this.setState((state, props) => ({
      filter: Object.assign(state.filter, { [name]: value })
    }))
  }

  handleSubmit(e) {
    e.preventDefault()

    const currentRequest = jQuery.ajax({
      method: 'POST',
      url: window.appData.filters_path,
      data: {
        filter: Object.assign({}, this.state.filter, {
          json_params: this.props.params,
          scope_type: this.props.scopeType,
          scope_id: this.props.scopeId,
          columns_order: this.props.columns && this.state.filter?.has_columns_order ? this.props.columns.map(col => col.name || col.getter) : null,
          columns_visibility: this.props.userColumns && this.state.filter?.has_columns_order ? this.props.userColumns : null
        })
      },
      dataType: 'json',
      beforeSend: (xhr) => {
        if (this.currentRequest) {
          this.currentRequest.abort()
        }
        this.setState({ loading: true })
        this.currentRequest = null
      },
      success: (data) => {
        this.props.addFilter(data)
        if (window.reactMagnificPopup) window.reactMagnificPopup.setState({ visible: false })
      },
      error: (data) => {
        if (data.responseJSON && data.responseJSON.errors) {
          this.setState({
            filter: Object.assign({}, this.state.filter, {
              errors: data.responseJSON.errors,
              full_messages: data.responseJSON.full_messages
            })
          })
        } else {
          if (data.responseJSON) {
            console.log(data.responseJSON)
          } else {
            alert(I18n.t('unexpected-error'))
          }
        }
      },
      complete: () => {
        this.setState({ loading: false })
        this.currentRequest = null
      }
    })
    this.currentRequest = currentRequest
  }

  closePopup(e) {
    e.preventDefault()
    if (window.reactMagnificPopup) window.reactMagnificPopup.setState({ visible: false })
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit.bind(this)}>
        <h1>{I18n.t('save-filter')}</h1>
        <Input
          name="name"
          type="text"
          autoComplete="off"
          autoFocus={true}
          object={this.state.filter}
          onChange={this.handleInputChange.bind(this)}
        />
        <Input name="default" type="checkbox" object={this.state.filter} onChange={this.handleInputChange.bind(this)} />
        {!['calendar', 'companies', 'products'].includes(this.props.type) ? (
          <Input
            name="save_dates"
            type="checkbox"
            object={this.state.filter}
            onChange={this.handleInputChange.bind(this)}
          />
        ) : null}
        {this.props.tableView ?
          <Input
            name="has_columns_order"
            type="checkbox"
            object={this.state.filter}
            onChange={this.handleInputChange.bind(this)}
            tooltip={I18n.t('has-columns-order')}
          /> : null
        }
        {this.props.scopeType ? (
          <Input
            name="shared_in_objects"
            type="checkbox"
            object={this.state.filter}
            onChange={this.handleInputChange.bind(this)}
            tooltip={I18n.t('shared-in-objects-tooltip')}
          />
        ) : null}
        {!this.props.shared_disabled && window.appData && window.appData.can_access_settings ? 
          <>
            <Input
              name="shared"
              type="checkbox"
              object={this.state.filter}
              onChange={this.handleInputChange.bind(this)}
              tooltip={I18n.t('shared-tooltip')}
            />
            {this.state.filter.shared && window.appData ?
              <div className="form-group">
                <label htmlFor="">{I18n.t('activerecord.attributes.filter.share_user_ids')}</label>
                
                <div className="select-wrapper select2-users-wrapper">
                  <input
                    type="text"
                    name="share_user_ids"
                    id="select2-users"
                    className="input-sm form-control select2-ajax select2-react-manual user"
                    data-url={`${window.appData.api_path}/users`}
                    data-multiple="true"
                    data-active={false}
                    autoComplete="off"
                    placeholder={I18n.t('mentions-all')}
                    onChange={this.handleInputChange.bind(this)}
                    value={this.state.filter?.share_user_ids ? this.state.filter.share_user_ids.split(',') : ''}
                  />
                </div>
              </div> : null
            }
          </> : null}
        <div className="form-footer">
          <a href="#" className="btn btn-thin btn-lg" onClick={this.closePopup.bind(this)}>
            {I18n.t('cancel')}
          </a>
          <button
            className={classNames('btn btn-primary btn-lg wide', { disabled: this.state.loading })}
            disabled={this.state.loading}
          >
            {I18n.t('save')}
          </button>
        </div>
      </form>
    )
  }
}

export default FormFilter
